"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisposeItemSchema = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var TextArea_1 = __importDefault(require("antd/lib/input/TextArea"));
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var removeUndefined_1 = __importDefault(require("common/utils/removeUndefined"));
var formik_1 = require("formik");
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Yup = __importStar(require("yup"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var productsList_1 = require("common/global/productsList");
var warehouseDisposeOperationsSlice_1 = require("src/features/warehouseDisposeOperations/warehouseDisposeOperationsSlice");
var moment_1 = __importDefault(require("moment"));
var warehouseItemsSlice_1 = require("src/features/warehouseItems/warehouseItemsSlice");
var Option = antd_1.Select.Option;
exports.DisposeItemSchema = Yup.object().shape({
    productId: Yup.string().required(),
    stockNumber: Yup.string().required(),
    damageReportNumber: Yup.string().required(),
});
function DisposeItemDialog(props) {
    var _a, _b;
    var currentUser = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }).currentUser;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var _c = (0, react_1.useState)(false), uploading = _c[0], setUploading = _c[1];
    var modalState = props.modalState, warehouseItems = props.warehouseItems, setModalState = props.setModalState;
    var t = (0, react_i18next_1.useTranslation)().t;
    var formProps = (0, formik_1.useFormik)({
        initialValues: {
            productId: "",
            projectId: "",
            stockNumber: undefined,
            quantity: 1,
            serialNumbers: [],
            notes: "",
            fileAttached: "",
            damageReportNumber: "",
        },
        validationSchema: exports.DisposeItemSchema,
        onSubmit: function (values, form) {
            var _a, _b, _c, _d;
            var product = productsList_1.globalProductsData[values.productId];
            var sameProducts = warehouseItems.find(function (x) {
                return x.stockNumber === formProps.values.stockNumber &&
                    x.productId === formProps.values.productId;
            });
            var _e = lodash_1.zip.apply(void 0, ((_a = values.serialNumbers) !== null && _a !== void 0 ? _a : []).map(function (x) { return x.split(":"); })
            // values.serialNumbers.split(":")
            ), serialNumbers = _e[0], assetsNumbers = _e[1];
            var quantity = product.serialNumbered
                ? values.serialNumbers.length
                : values.quantity;
            if (quantity === 0) {
                throw new Error("QuantityMustBePositive");
            }
            var sameProductQuantity = sameProducts
                ? sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.quantity
                : undefined;
            var userId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
            dispatch((0, warehouseDisposeOperationsSlice_1.addDisposeOperation)((0, removeUndefined_1.default)({
                warehouseId: props.warehouseId,
                projectId: sameProducts.projectId,
                productId: values.productId,
                stockNumber: values.stockNumber,
                batchNumber: (_b = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.batchNumber) !== null && _b !== void 0 ? _b : "",
                serialNumbers: product.serialNumbered ? serialNumbers : [],
                assetsNumbers: product.serialNumbered ? assetsNumbers : [],
                quantity: quantity,
                createdAt: (0, moment_1.default)(),
                updatedAt: (0, moment_1.default)(),
                cachedProductName: product.name,
                cachedProductUnit: product.unitId,
                cachedProductDescription: product.description,
                notes: (_c = values.notes) !== null && _c !== void 0 ? _c : "",
                disposedBy: userId,
                fileAttached: values.fileAttached,
                cachedProductCategory: product.categoryId,
                budgetLineId: (_d = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.budgetLineId) !== null && _d !== void 0 ? _d : "",
                damageReportNumber: values.damageReportNumber,
                expiryDate: sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.expiryDate,
                before: sameProductQuantity !== null && sameProductQuantity !== void 0 ? sameProductQuantity : 0,
                after: sameProductQuantity - quantity,
            })));
            var newQuantity = sameProductQuantity - quantity;
            if (newQuantity < 0) {
                antd_1.message.error("الكمية المصروفة اكبر من الكمية الحالية!");
            }
            else {
                dispatch((0, warehouseItemsSlice_1.editWarehouseItem)({
                    id: sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.id,
                    quantity: newQuantity,
                    serialNumbers: sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.serialNumbers.filter(function (x) { return !serialNumbers.includes(x); }),
                    assetsNumbers: sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.assetsNumbers.filter(function (x) { return !assetsNumbers.includes(x); }),
                }))
                    .then(function () {
                    antd_1.message.success(t("alerts.success"));
                    setModalState(undefined);
                    form.resetForm();
                })
                    .catch(function (e) {
                    console.log(e);
                    if (e.message === "QuantityMustBePositive") {
                        antd_1.message.error("Quantity must be positive");
                    }
                    else {
                        antd_1.message.error(t("alerts.error"));
                    }
                });
            }
        },
    });
    var sameProducts = warehouseItems.find(function (x) { return x.stockNumber === formProps.values.stockNumber; });
    var product = productsList_1.globalProductsData[formProps.values.productId];
    var max = (_a = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.quantity) !== null && _a !== void 0 ? _a : 0;
    return ((0, jsx_runtime_1.jsx)(antd_1.Modal, __assign({ title: "Disposal Itemss", open: modalState, onOk: formProps.submitForm, onCancel: function () { return setModalState(undefined); }, okButtonProps: { disabled: uploading }, confirmLoading: formProps.isSubmitting }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, __assign({ labelCol: { span: 8 }, wrapperCol: { span: 16 } }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("productId").touched) &&
                        formProps.errors.productId &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("productId").touched) &&
                        formProps.errors.productId, label: t("common.product") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ showSearch: true, optionFilterProp: "children", value: formProps.values.productId, onSelect: function (e) {
                            formProps.setFieldValue("productId", e);
                            formProps.setFieldValue("projectId", undefined);
                            formProps.setFieldValue("quantity", undefined);
                            formProps.setFieldValue("stockNumber", undefined);
                            formProps.setFieldValue("notes", undefined);
                        } }, { children: (0, lodash_1.uniqBy)(warehouseItems.filter(function (e) {
                            return e.quantity > 0;
                        }), "productId").map(function (item, key) {
                            var _a;
                            var unit = (_a = unitsList_1.globalUnitsData[item.cachedProductUnit]) === null || _a === void 0 ? void 0 : _a.name;
                            return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: item.productId }, { children: "".concat(item.cachedProductName, "/ ").concat(item.cachedProductDescription, "/ ").concat(unit) }), key));
                        }) })) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("stockNumber").touched) &&
                        formProps.errors.stockNumber &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("stockNumber").touched) &&
                        formProps.errors.stockNumber, label: t("warehouse.stockNumber") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ maxTagCount: 1, value: formProps.values.stockNumber, onChange: function (e) {
                            formProps.setFieldValue("stockNumber", e);
                        } }, { children: warehouseItems
                            .filter(function (x) {
                            return x.productId === formProps.values.productId && x.stockNumber;
                        })
                            .map(function (x) { return ((0, jsx_runtime_1.jsx)(antd_1.Select.Option, __assign({ value: x.stockNumber }, { children: x.stockNumber }), x.stockNumber)); }) })) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ label: t("common.project") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ showSearch: true, optionFilterProp: "children", value: sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.projectId, disabled: true }, { children: (0, jsx_runtime_1.jsx)(Option, __assign({ value: sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.projectId }, { children: (_b = projectsList_1.globalProjectsData[sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.projectId]) === null || _b === void 0 ? void 0 : _b.code }), sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.projectId) })) })), product && !product.serialNumbered ? ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("quantity").touched) &&
                        formProps.errors.quantity &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("quantity").touched) &&
                        formProps.errors.quantity, label: t("common.quantity") }, { children: (0, jsx_runtime_1.jsx)(antd_1.InputNumber, { type: "number", max: max, min: 0, value: formProps.values.quantity, onChange: function (e) { return formProps.setFieldValue("quantity", e); } }) }))) : null, product && product.serialNumbered ? ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("serialNumbers").touched) &&
                        formProps.errors.serialNumbers &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("serialNumbers").touched) &&
                        formProps.errors.serialNumbers, label: t("warehouse.serialNumbers") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ mode: "tags", value: formProps.values.serialNumbers, onChange: function (e) { return formProps.setFieldValue("serialNumbers", e); } }, { children: warehouseItems
                            .filter(function (x) {
                            return x.productId === formProps.values.productId &&
                                // x.projectId === formProps.values.projectId &&
                                x.stockNumber === formProps.values.stockNumber;
                        })
                            .map(function (x) {
                            return x.serialNumbers.map(function (serial, idx) { return ((0, jsx_runtime_1.jsxs)(antd_1.Select.Option, __assign({ value: "".concat(serial, ":").concat(x.assetsNumbers[idx]) }, { children: [serial, "/", x.assetsNumbers[idx]] }), serial)); });
                        }) })) }))) : null, (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("damageReportNumber").touched) &&
                        formProps.errors.damageReportNumber &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("damageReportNumber").touched) &&
                        formProps.errors.damageReportNumber, label: t("warehouse.damageReportNumber") }, { children: (0, jsx_runtime_1.jsx)(TextArea_1.default, { value: formProps.values.damageReportNumber, onChange: formProps.handleChange("damageReportNumber") }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("notes").touched) &&
                        formProps.errors.notes &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("notes").touched) &&
                        formProps.errors.notes, label: t("common.notes") }, { children: (0, jsx_runtime_1.jsx)(TextArea_1.default, { value: formProps.values.notes, onChange: formProps.handleChange("notes") }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("notes").touched) &&
                        formProps.errors.notes &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("notes").touched) &&
                        formProps.errors.notes })] })) })));
}
exports.default = DisposeItemDialog;
